import React from 'react';
import './App.css';
import Routes from './routes/Routes'


const App = () => {
  return (
    <div className="App">
      <main>
        <Routes/>
      </main>
    </div>
  );
}

export default App;
